<template>
    <div class>
        <div class="box box--spaces">
            <div style="width: 100%">
                <ul class="scroll">
                    <li
                        v-for="link in links"
                        :key="link.id"
                        class="li__item"
                        :class="{
                            'li__item--selected': activeLink === link.id
                        }">
                        <a href="#"
                            @click.prevent.stop="() => onClick(link)"
                            class="content">
                            {{link.title}}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    links: {
      type: Array
    },
    activeLink: {
      type: String
    },
    onClick: {
      type: Function
    }
  }
};
</script>


<style lang="scss" scoped>
ul {
    padding: 0;
}

.scroll {
  white-space: nowrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: -ms-autohiding-scrollbar;
  width: 100%;
  display: flex;

  li {
    border: none;
    border-bottom: 0.1rem solid #d0d0d0;
    flex: 1 1 0;
    list-style-type: none;
  }

  li.li__item--selected {
    border-bottom: 0.2rem solid #00aeba;
  }
}
.scroll::-webkit-scrollbar {
  display: none;
}

.content {
    padding: 1.6rem 2.4rem;
    text-align: center;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    font-weight: bold;
    color: #747B8C;
}
</style>
